import { Component, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";
import { getDocsByType } from "../api.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { formatDate } from "../utils/date.util";
import { Part } from "../../../../shared/models/part";
import { Manufacturer } from "../../../../shared/models/manufacturer";
import { Alert } from "../../../../shared/types/alerts";
import { Message } from "../../../../shared/models/message";

@Component({
    selector: "app-export",
    templateUrl: "./export-data.component.html",
    styleUrls: ["./export-data.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportDataComponent {
  app = getApp((app) => {
    this.app = app;
  });

  downloadJsonHref: string = "";
  selectedValues: string[] = [];

  constructor(private sanitizer: DomSanitizer) {}

  async ngOnInit() {
    // await this.showData("part");
  }

  onCheckboxChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const value = checkbox.value;
    if (checkbox.checked) {
      this.selectedValues.push(value);
    } else {
      this.selectedValues = this.selectedValues.filter((v) => v !== value);
    }
  }

  async exportData(event: MouseEvent) {
    event.preventDefault();
    this.downloadJsonHref = "";

    if (this.selectedValues.length === 0) {
      return;
    }
    this.app.spinner.showSpinner();
    const docsToExport: JSONExport = new JSONExport();
    for (const value of this.selectedValues) {
      if (value === "part") {
        let parts = await getDocsByType(
          this.app.customers.expectCurrent,
          value
        );
        docsToExport.parts = parts as Part[];
      }
      if (value === "manufacturer") {
        let manufacturers = await getDocsByType(
          this.app.customers.expectCurrent,
          value
        );
        docsToExport.manufacturers = manufacturers as Manufacturer[];
      }
      if (value === "alert") {
        let alerts = await getDocsByType(
          this.app.customers.expectCurrent,
          value
        );
        docsToExport.alerts = alerts as Alert[];
      }
      if (value === "message") {
        let messages = await getDocsByType(
          this.app.customers.expectCurrent,
          value
        );
        docsToExport.messages = messages as Message[];
      }
    }

    const jsonDocs = JSON.stringify(docsToExport);
    const blob = new Blob([jsonDocs], { type: "application/json" });
    this.downloadJsonHref = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = this.downloadJsonHref;
    a.download = this.createFileName();
    a.click();

    setTimeout(() => {
      URL.revokeObjectURL(this.downloadJsonHref);
    }, 1000);

    this.app.spinner.hideSpinner();
  }

  createFileName() {
    const currentDate = formatDate(Date.now(), "YYYYMMDD");
    return (
      currentDate +
      "-" +
      this.app.customers.expectCurrent +
      "-" +
      "export" +
      ".json"
    );
  }
}
class JSONExport {
  parts?: Part[] = [];
  manufacturers?: Manufacturer[] = [];
  alerts?: Alert[] = [];
  messages?: Message[] = [];
}
